import { NextResponse } from "next/server";

export function middleware(request) {
    const country = request.headers.get("x-vercel-ip-country");

    if (country === "IN") {
        return new NextResponse("Access denied", {
            status: 403,
            headers: {
                "Content-Type": "text/plain",
            },
        });
    }

    return NextResponse.next();
}

export const config = {
    matcher: [
        /*
         * Match all routes except static files and Next.js internals
         */
        "/((?!_next/static|_next/image|favicon.ico).*)",
    ],
};